import ScrollUtils from 'frontools/utils/ScrollUtils';
/*
* Object fit 
* @param
*/

export default class Utils {
    /**
    * Choose replacement background size type  
    * @static
    * @param {string} type
    * @memberOf ObjectFit
    */
    public static objectFitPolyfill(type: string = 'cover') {
        if ('objectFit' in document.documentElement.style === false) {
            console.info('object-fit not natively supported');
            
            let els = document.querySelectorAll('[data-object-fit="'+ type +'"]') as NodeListOf<HTMLElement>;    
            for (var i = 0; i < els.length; i++) {   
                var container = els[i] as HTMLElement;
                var img = container.querySelector('img');
                if (img) {
                    let src = container.querySelector('img').getAttribute('src');
                    container.style.backgroundImage = 'url(' + src + ')';
                    container.style.backgroundSize = type; 
                    container.style.backgroundPosition = '50% 50%';
                    container.style.width = '100%';
                    container.style.height = '100%';
                    img.style.opacity = '0'; // img is invisible but still has width and height
                }
            }
        }
    }

}

/*
    Utils.objectFitPolyfill('cover');
    
    * HTML
    <div class="object-fit-wrp" data-object-fit="cover">
        <img class="object-fit" src="{{ slide.slideImage.first().getUrl() }}" alt="">
    </div>
    
    * CSS
    .object-fit {
        object-fit: cover;
        width: 100%;
        height: 100%;
        @media #{$mqTabletP} {
            object-fit: fill;
        }
    }
    .object-fit-wrp {
        height: 100%;
        width: 100%;
    }

*/